import type { TopBarDropdownContextProps } from './TopBarDropdownContext';
import type { TopBarDropdownContextWrapperProps } from './TopBarDropdownContextWrapper.types';
import { useFavoriteOptions } from 'Components/TopBar/hooks/useFavoriteOptions';
import { MobXProviderContext } from 'mobx-react';
import { useCallRouter } from 'Modules/softphone/hooks';
import React from 'react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import { TopBarDropdownContext } from './TopBarDropdownContext';

export const TopBarDropdownContextWrapper: React.FC<
  TopBarDropdownContextWrapperProps
> = ({ children }) => {
  const {
    person: { loadPersonByIdGet },
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const { callWithPerson } = useCallRouter();

  const { favoriteList, mapFavoritesOptions } = useFavoriteOptions();

  const [options, setOptions] = React.useState<
    TopBarDropdownContextProps['options']
  >([]);

  const [selection, setSelection] = React.useState<
    TopBarDropdownContextProps['selection']
  >({ users: [], variant: null });

  const makeCall = async (
    data: { personId?: string; phoneNumbers?: string[] },
    e?: React.MouseEvent
  ) => {
    if (data.phoneNumbers?.length > 1) return;

    const users = data.personId ? [data.personId] : [data.phoneNumbers[0]];
    const numberIsInsideOptions = options.some(async ({ key }) => {
      try {
        const p = await loadPersonByIdGet(key);

        return (
          users.includes(key) ||
          (!!p?.lines?.length && users.includes(p.lines[0]?.number))
        );
      } catch (err) {
        console.warn(
          `Failed to load Person ${key}.  This may be caused by a removed Person or unassigned number, which is not an error.`,
          err
        );
        return false;
      }
    });

    if (!numberIsInsideOptions) return;
    e?.stopPropagation();
    return data?.phoneNumbers?.length === 1
      ? callWithPerson(undefined, data?.phoneNumbers[0])
      : callWithPerson(data.personId, undefined);
  };

  return (
    <TopBarDropdownContext.Provider
      value={{
        makeCall,
        options,
        setOptions,
        selection,
        setSelection,
        favoriteList,
        mapFavoritesOptions,
      }}
    >
      {children}
    </TopBarDropdownContext.Provider>
  );
};
